module.exports = __webpack_public_path__ + "img/2.096161ee.png";